import React, { Component } from 'react';
import {
	IDocumentPreviewProps,
	IDocumentPreviewState,
} from './models';
import { inject, observer } from 'mobx-react';
import { InjectedStyledComponent } from '../shared/InjectedStyledComponent';
import Wrapper from './styledComponents/Wrapper';
import PreviewWrapper from './styledComponents/PreviewWrapper';
import Preview from './styledComponents/Preview';
import NoPreview from './styledComponents/NoPreview';
import CloseIcon from './styledComponents/CloseIcon';
import ClickLayer from './styledComponents/ClickLayer';
import { utils } from '@kurtosys/ksys-app-template';
import Translate from '@kurtosys/ksys-app-components/dist/components/base/Translate';

@inject('appStore', 'documentPreviewStore')
@observer
export class DocumentPreview extends Component<IDocumentPreviewProps, IDocumentPreviewState> {
	static configurationKey: 'documentPreview' = 'documentPreview';
	static styleKey: 'documentPreview' = 'documentPreview';
	constructor(props: IDocumentPreviewProps) {
		super(props);
	}

	render() {
		const { className, documentPreviewStore } = this.props;

		if (!documentPreviewStore || utils.typeChecks.isNullOrUndefined(documentPreviewStore.selectedDocument)) {
			return null;
		}

		const { documentUrl, isPreviewable, noPreviewMessage, clearDocumentPreview } = documentPreviewStore;

		return (
			<Wrapper className={ className }>
				<ClickLayer onClick={ clearDocumentPreview } />
				<PreviewWrapper>
					{ isPreviewable && <Preview data={ documentUrl || '' } /> }
					{ !isPreviewable && (
						<NoPreview>
							<Translate>{ noPreviewMessage }</Translate>
							<CloseIcon onClick={ clearDocumentPreview } asset={ 'base.toast.close' } alt={ 'X' } />
						</NoPreview>
					) }
				</PreviewWrapper>
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(DocumentPreview, 'documentPreview');

